var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketTurret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.3739 19.215L84.2829 18.8355V6.34799L83.8179 5.57399L83.1849 2.78699H81.5799L81.0099 3.54749C81.0099 3.54749 73.0209 4.43999 72.4839 4.49849C71.9469 4.55699 72.0354 5.02649 72.0354 5.02649L66.7554 4.85699V3.54749H65.2779L63.9264 5.02499L62.5959 5.04599L61.8984 5.74349H43.8219L43.6959 7.36199L42.9774 8.65649V16.6815H43.6959V18.9615L61.8984 19.215L61.1799 19.9755L61.2429 26.1735L62.5314 27.324H64.6569L66.0924 26.916L70.3869 26.7435L71.2734 25.635L72.6339 26.916L68.5704 30.66H66.8394L66.1209 31.5885L65.3394 31.9425L65.0229 37.3185L51.9309 50.637L45.7179 50.739L44.4129 51.3135L42.6384 54.945L37.7574 55.1145L35.8809 57.2265L37.1199 57.903H75.9354L77.0964 56.9595L75.3294 55.116L69.7539 54.834L69.6354 53.5665L66.3759 50.469L65.1939 50.2155L65.1099 48.864L66.1869 48.906L67.1484 48.6255L68.1519 47.7375L72.2739 43.398L76.2669 39.27C76.2669 39.27 77.7714 37.224 78.1719 36.3345C78.5709 35.4465 78.0774 33.786 78.0774 33.786L81.4554 32.3505L81.2439 30.6195H79.2789L79.3929 27.753C79.3929 27.753 79.9419 26.652 80.0979 25.6845C80.2539 24.7185 79.1259 23.0745 79.1259 23.0745L85.4679 22.488L86.3739 19.2165V19.215ZM62.4489 25.635L62.4069 21.1155L63.3354 19.215L64.0539 19.806H65.5719C65.5719 19.806 65.5749 20.988 65.5719 21.1155C65.5689 21.2415 66.8019 22.281 66.8019 22.281C66.8019 22.281 66.8409 23.481 66.9204 23.7255C66.9999 23.97 67.9419 23.904 67.9419 23.904L69.0369 25.4175L62.4489 25.635V25.635Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3125 49.7072L56.664 48.4412L57.339 49.7072H55.3125Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6494 47.3986L58.9724 46.0471L62.7449 47.1181L60.5909 49.4266H58.5779L57.6494 47.3986Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 44.8936L64.7445 39.8536L67.0815 45.3151L65.5605 46.8646L60 44.8936Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1791 44.4421L73.1906 39.5146H66.0956L68.1791 44.4421Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1786 31.5901H71.5016L73.1906 30.5056H77.2451H79.5251",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 36.1201H78.2587",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2451 30.5056V36.0241",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.999 34.6397V32.7302L74.532 31.7162H76.395V34.8137H72.999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.082 37.7131H66.8565L70.0095 34.8136V32.5891H65.1105",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1096 19.4402V18.6512L69.3896 17.0192H71.5301L73.6691 18.5387V19.8062",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8526 20.2291V21.0451L73.6691 22.3396H67.1096",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1504 23.9027H74.1759L76.3944 21.5807V19.6652",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9631 26.9161C77.5305 26.9161 77.9905 26.4561 77.9905 25.8886C77.9905 25.3212 77.5305 24.8611 76.9631 24.8611C76.3956 24.8611 75.9355 25.3212 75.9355 25.8886C75.9355 26.4561 76.3956 26.9161 76.9631 26.9161Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9628 28.0516C78.1574 28.0516 79.1258 27.0832 79.1258 25.8886C79.1258 24.694 78.1574 23.7256 76.9628 23.7256C75.7682 23.7256 74.7998 24.694 74.7998 25.8886C74.7998 27.0832 75.7682 28.0516 76.9628 28.0516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5617 25.0531L76.3947 26.7436",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0426 53.2981C58.47 53.2981 58.8166 52.9516 58.8166 52.5241C58.8166 52.0967 58.47 51.7501 58.0426 51.7501C57.6151 51.7501 57.2686 52.0967 57.2686 52.5241C57.2686 52.9516 57.6151 53.2981 58.0426 53.2981Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2362 52.0172H64.0117V53.5652H66.3772",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4276 50.6371V55.1132",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0771 7.36066H47.8496H62.2946",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8496 7.36066V8.65666H57.3671V7.36066",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6181 11.3596H54.9726H54.0156V13.4431H62.6181",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.918 13.4431V11.3596",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1201 15.0482H62.6186",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 12.0557H46.0635V12.5147H46.5225V12.0557Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5722 8.83063H65.3427V10.3336H65.5722V8.83063Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5722 14.4617H65.3427V15.9647H65.5722V14.4617Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6113 8.83069H75.3818V10.3337H75.6113V8.83069Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7454 6.6106H78.1709V9.0061H78.7454V6.6106Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7454 10.7491H78.1709V13.8451H78.7454V10.7491Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7454 15.9646H78.1709V18.6871H78.7454V15.9646Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6113 14.4617H75.3818V15.9647H75.6113V14.4617Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9063 12.0557H47.4473V12.5147H47.9063V12.0557Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.974 15.0482H77.4415",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7383 9.86719H84.3968",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6191 9.38867H77.4421",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8574 15.4142H77.3024",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1096 5.27718V6.09468L69.3326 7.67118H71.5301L73.5281 6.29118V5.02368",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2426 3.54614L80.3711 5.44664",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7783 18.8777V22.8092",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9911 19.2151V19.9471L81.6086 20.2291",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5459 34.3096C67.7655 34.3096 67.9434 34.1317 67.9434 33.9121C67.9434 33.6926 67.7655 33.5146 67.5459 33.5146C67.3264 33.5146 67.1484 33.6926 67.1484 33.9121C67.1484 34.1317 67.3264 34.3096 67.5459 34.3096Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5358 25.6831C73.6096 25.6831 73.6693 25.6234 73.6693 25.5496C73.6693 25.4759 73.6096 25.4161 73.5358 25.4161C73.4621 25.4161 73.4023 25.4759 73.4023 25.5496C73.4023 25.6234 73.4621 25.6831 73.5358 25.6831Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0964 22.5481C77.1701 22.5481 77.2299 22.4884 77.2299 22.4146C77.2299 22.3409 77.1701 22.2811 77.0964 22.2811C77.0227 22.2811 76.9629 22.3409 76.9629 22.4146C76.9629 22.4884 77.0227 22.5481 77.0964 22.5481Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2788 27.8911V30.6181H81.4538V32.3491L78.0758 33.7846C78.0758 33.7846 78.7943 36.5296 76.8503 38.6416C74.9078 40.7536 67.8968 47.8486 67.8968 47.8486C67.8968 47.8486 67.2638 48.9466 66.1868 48.9046L65.1098 48.8626V50.4676H66.3773L69.7553 53.6776V55.1131H75.3308L77.2733 57.1396L76.3448 57.9001H36.8123L35.8838 57.2251L37.9103 54.9451H42.6398L44.4143 51.3136C44.4143 51.3136 45.0893 50.6386 46.7798 50.6386H51.9323L65.1098 36.8701V32.6461C65.1098 32.6461 65.1098 31.5901 66.1238 31.5901H66.8423V30.6616H68.5733L72.8813 26.6911L71.2763 25.6351L70.7273 26.8171L65.5328 26.9011L64.9418 27.3241H62.5343L62.1113 26.8171C62.1113 26.8171 61.1393 26.6911 61.1393 25.6351C61.1393 24.5791 61.1813 19.9756 61.1813 19.9756H62.9978L62.4488 20.8201L62.5328 21.9181L62.4488 25.6351H69.5438L68.2343 24.7906L68.1503 23.9041H66.9248L66.8828 22.3411L65.6153 21.4126V19.7656H63.9263L62.6168 19.2166L61.8563 18.9631H43.6958V16.6831H42.9773V8.27559L43.8218 7.64259V5.74209H61.8983L62.5958 5.04459H64.1378L65.2778 3.54459H66.7553V5.02209H72.2873V4.51509L81.2408 3.54309L81.5783 2.78259H83.4788L83.8163 5.56959L84.2813 5.61159V18.8341L86.6048 19.2571L85.6763 22.4671L78.8348 23.1001C78.8348 23.1001 80.4818 24.7051 80.0168 26.3941C79.5518 28.0831 78.5393 29.0971 75.7928 28.8016L72.8783 26.6896",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6184 19.2151V5.04608",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2891 5.02356H77.0621L77.4416 5.86956H83.8196",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4417 5.86963V19.8061H65.6172",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7383 18.8776H84.2843",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6973 16.6801H62.6183",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8404 31.5901H69.8389L74.7814 36.3616V39.4021H65.0254L65.1094 36.8686",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1098 50.4676H57.2963L56.0723 51.7351V55.1131",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7556 55.1132H42.6416",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M66.377 50.4677V55.1132",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketTurret);
export default __webpack_public_path__ + "static/media/Rocket Turret.95ca51967f6ffbeb95cc0716049147f4.svg";
export { ForwardRef as ReactComponent };